import { Eye, MoreVertical, PencilLineIcon, Trash2 } from "lucide-react";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const DROPDOWN_WIDTH = 180; // px
const dropdownMenuStyles = {
  position: "absolute",
  top: "36px",
  right: "0",
  minWidth: "180px",
  width: "180px",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  zIndex: 10,
  padding: "6px 0",
  border: "1px solid #eaf6ff",
};
const dropdownOptionStyles = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "10px 18px",
  fontSize: "13px",
  color: "#6B7280",
  //   background: "#F2F9FD",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  margin: "4px 8px",
  transition: "background 0.2s",
};
const dropdownOptionHover = {
  background: "#F3F4F6",
};

function ActionsDropdown({ onViewProfile, onRemoveUser, onReviewSession, styles }) {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
  const btnRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownPos, setDropdownPos] = useState({
    top: 0,
    left: 0,
    width: 180,
  });

  useLayoutEffect(() => {
    if (open && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY,
        left: rect.right + window.scrollX - DROPDOWN_WIDTH,
      });
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (btnRef.current && btnRef.current.contains(e.target)) {
        return;
      }
      if (dropdownRef.current && dropdownRef.current.contains(e.target)) {
        return;
      }
      setOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        className={styles.rowActionsBtn}
        onClick={() => setOpen((o) => !o)}
        tabIndex={0}
        aria-label="Row actions"
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
        ref={btnRef}
      >
        <MoreVertical size={22} color="#798797" />
      </button>
      {open &&
        createPortal(
          <div
            ref={dropdownRef}
            style={{
              ...dropdownMenuStyles,
              position: "absolute",
              top: dropdownPos.top,
              left: dropdownPos.left,
              minWidth: "180px",
              width: "180px",
              zIndex: 9999,
            }}
          >
            <div
              style={
                hovered === 0
                  ? { ...dropdownOptionStyles, ...dropdownOptionHover }
                  : dropdownOptionStyles
              }
              onMouseEnter={() => setHovered(0)}
              onMouseLeave={() => setHovered(null)}
              tabIndex={0}
              onClick={() => {
                setOpen(false);
                onViewProfile && onViewProfile();
              }}
            >
              <PencilLineIcon size={18} /> Edit Session
            </div>
            <div
              style={
                hovered === 1
                  ? { ...dropdownOptionStyles, ...dropdownOptionHover }
                  : dropdownOptionStyles
              }
              onMouseEnter={() => setHovered(1)}
              onMouseLeave={() => setHovered(null)}
              tabIndex={0}
              onClick={() => {
                setOpen(false);
                onRemoveUser && onRemoveUser();
              }}
            >
              <Trash2 size={18} /> Remove Session
            </div>
            <div
              style={
                hovered === 2
                  ? { ...dropdownOptionStyles, ...dropdownOptionHover }
                  : dropdownOptionStyles
              }
              onMouseEnter={() => setHovered(2)}
              onMouseLeave={() => setHovered(null)}
              tabIndex={0}
              onClick={() => {
                setOpen(false);
                onRemoveUser && onReviewSession();
              }}
            >
              <Eye size={18} /> Review Session
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}

export default ActionsDropdown;
